<div class="park-access">
  <h4 class="park-access-title">¿Necesitas una habitación accesible?</h4>

  <div class="park-access-grid">
    <div class="park-access-card" *ngFor="let c of cards; trackBy: trackByKey" [class.selected]="c.key === selectedKey"
         [style.border-color]="c.key === selectedKey ? buttonColorActive : null">
      <div class="park-access-body">
        <p class="park-access-name">{{ c.title }}</p>
        <p class="park-access-desc">{{ c.subtitle }}</p>
      </div>
      <div class="park-access-footer">
        <p class="park-access-price" *ngIf="c.price !== null">
          {{ currencyAgency?.code }} {{ c.price | currencyConverterPure: c.currency: currencyAgency?.code: currencies | number: '1.2-2' }}
          <usb-tooltip-convert-amount *ngIf="clientSetting"
                                      [clientsSettingAppBooking]="clientSetting"
                                      [currencyProduct]="c.currency"
                                      [valueProduct]="c.price">
          </usb-tooltip-convert-amount>
        </p>
        <button type="button" class="park-access-btn" [style.background-color]="buttonColorActive" (click)="pick(c)">
          {{ c.key === selectedKey ? 'Seleccionada' : 'Seleccionar' }}
        </button>
      </div>
    </div>
  </div>
</div>
